import isMobile from 'ismobilejs'


const styles = (theme) => ({
  modal: {
    "& .MuiPaper-root" :{
      maxHeight:'90%',
      width:'90%'
    }
  },
  container: {
    overflowX: 'hidden'
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop:'65px'
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  inputCode:{
    margin: '15px 0 15px 0',
    fontWeight: '40px',
    "& .ReactInputVerificationCode__container": {
      width: isMobile.any ? '320px' : '400px',
      gap: '10px',
      fontFamily:'UniNeue',
      fontWeight: '800'
    },
    "& .ReactInputVerificationCode__input": {
      position: 'fixed'
    },
    
  },
  aaLoaderModal: {
    height: isMobile.any ? '100vh' : '70vh' ,
    width: isMobile.any ? '100%' : '350px',
    display: 'grid',
    justifyContent: 'center',
    alignContent: 'center'
  },
  aaLoader:{
    height: '100vh',
    display: 'grid',
    justifyContent: 'center',
    alignContent: 'center'
  },
  verificationFail:{
    marginTop: '10px',
    color:'red',
  },
  title:{
    marginBottom: "25px", 
    textAlign: "center",
    fontSize: '20px',
    fontWeight: '700',
  },
  subtitle:{
    marginBottom: "14px" 
  },
  boldFont:{
    fontWeight: '700'
  },
  backIcon:{
    position: 'absolute',
    left: 8,
    top: 8,
    color: "#000000DE"
  },
  containerIcon:{
    width: '400px',
    color: '#000000DE'
  }
});

export default styles